@if (!isMobile) {
  <div class="top-container">
    <div class="site-config-header" rtlDiv>
      @for (site of siteObject; track site; let i = $index) {
      <span>{{site.site_name}}</span>
      @if (i < siteObject.length - 1) { <span>&nbsp;|&nbsp;</span>
        }
        }
    </div>
  </div>
  <div class="site-config-page">
    <div class="mat-grid-tile">
      <div class="title">{{ 'SITE_MANAGMENT.PRE_INS' | translate }}</div>
      <div class="link-h" (click)="openPreMapping()">{{ 'SITE_MANAGMENT.PRE_MAP_WIZARED' | translate }}</div>
    </div>
    <div class="mat-grid-tile">
      <div class="title">{{ 'SITE_MANAGMENT.BINS' | translate }}</div>
      <div class="link-h" (click)="openSwapUnit()">{{ 'SITE_MANAGMENT.SWAP_UNIT' | translate }}</div>
      <!-- <li><a routerLink="/binsmonitoring/{{ siteId }}">{{ 'WIDGETS.MANAGE_BINS' | translate }}</a></li> -->
    </div>
  </div>
}

@if (isMobile) {
  <div class="mobile-top-container">
    <div class="mobile-management-header">
        @for (site of siteObject; track site; let i = $index) {
        <span>{{site.site_name}}</span>
        @if (i < siteObject.length - 1) { <span>&nbsp;|&nbsp;</span>
      }
      }
    </div>
  </div>
  <div class="mobile-site-config-page">
    <div class="mobile-card">
      <div class="mobile-title">{{ 'SITE_MANAGMENT.BINS' | translate }}</div>
      <!-- <div class="mobile-title-sub"><a routerLink="/binsmonitoring/{{ siteId }}">{{ 'WIDGETS.MANAGE_BINS' | translate }}</a></div> -->
      <div class="mobile-title-sub" (click)="openSwapUnit()">{{ 'SITE_MANAGMENT.SWAP_UNIT' | translate }}</div>
    </div>
    <div class="mobile-card">
      <div class="mobile-title"> {{ 'SITE_MANAGMENT.PRE_INS' | translate }} </div>
      <div class="mobile-title-sub" (click)="openPreMapping()">{{ 'SITE_MANAGMENT.PRE_MAP_WIZARED' | translate }}</div>
    </div>
  </div>
}